var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout justify-center wrap container text-xs-center",staticStyle:{"font-size":"20px"}},[_vm._v("\n    "+_vm._s(_vm.$route.params.message)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }